/**
 * Rreviews Block.
 * 
 */

 let 
	$window = $(window),
	prevWindowW = $window.width(),
	currWindowW = prevWindowW,
	sliderBreakpoint = 768,

	$mySlider = $('.review-slides'),
	myOptions = {
		adaptiveHeight:false,
		arrows:true,
		appendArrows:$('.review-slides__arrow-nav'),
		centerMode:false,
		cssEase:'ease-out',
		dots:false,
		fade:true,
		infinite:true,
		// mobileFirst:true,
		slidesToShow:1,
		// slidesToScroll:2,
		swipe:true,
		swipeToSlide:true,
	};


function initReviewsSlider() {
	// Mobile: single slide, dot nav.
	// Desktop: 2 to 4 across slides, arrow nav.
	console.log('REVIEWS: initReviewsSlider()');

    let 
		wwidth = $(window).width();

	$mySlider.slick(myOptions);

	// unslickedHtml = $mySlider[0].outerHTML;

	// if (wwidth < sliderBreakpoint) {
	// 	$mySlider.slick(optionsMobile);
	// } else {
	// 	$mySlider.slick(optionsDesktop);
	// }
}

exports.init = function () {
	console.log('REVIEWS: exports.init');
	// Run init methods...

	initReviewsSlider();
};